export default __webpack_public_path__ + "static/media/services_delivery.34f6739c.png";